module.exports = __webpack_public_path__ + "static/media/SMBracketNBA_1080.d6cada45.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SMBracketNBA_1080.mp4
// module id = 168
// module chunks = 0